@use "Styles/mixins";
@use "Styles/includes/variables";

* {
    box-sizing: border-box;
}

:host {
    display: contents;
}

.vm-video-info-bottom-sheet {
    &__title {
        margin: 0;
        font-size: mixins.get-font-size(text-lg);
        font-weight: 900;
        line-height: mixins.get-line-height(text-lg);
        color: mixins.get-color(text, text-primary);
    }

    &__stats {
        display: flex;
        gap: 8px;
        width: 100%;
        margin-top: 8px;

        vm-kol-profile-stat-box {
            flex: 1;
        }
    }

    &__card {
        --vm-video-info-bottom-sheet-card-bg: #{mixins.get-color(background, bg-gray-100)};

        margin-top: 8px;
        padding: 16px;
        border-radius: 16px;
        background-color: var(--vm-video-info-bottom-sheet-card-bg);
        display: flex;
        align-items: center;
        gap: 16px;

        &--with-description {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 16px 0;
        }

        &--contributor,
        &--byline {
            position: relative;
        }
    }

    &__card-header {
        position: relative;
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 0 16px 16px;
        border-bottom: 2px solid mixins.get-color(bg, solid, primary);
    }

    &__card-link-overlay {
        position: absolute;
        inset: 0;
        border-radius: inherit;
        text-decoration: none;
        z-index: 0;
    }

    &__card-body {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 0 16px;
    }

    &__contributor-avatar {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        overflow: hidden;
    }

    &__contributor-name,
    &__byline-name {
        color: mixins.get-color(text, text-primary);
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        font-weight: 700;
        flex-grow: 1;
    }

    &__byline-avatar {
        width: 55px;
        height: 55px;
        flex-shrink: 0;
    }

    &__contributor-link,
    &__byline-link {
        border-radius: 50%;
        background: mixins.get-color(bg, solid, primary);
    }

    &__description {
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        color: mixins.get-color(text, text-primary);
        --vm-clamped-text-bg: var(--vm-video-info-bottom-sheet-card-bg);

        // As a flex item it defaults to min-width: auto, refusing to shrink
        // below its longest token; min-width: 0 lets it shrink so long URLs /
        // hashtag runs can wrap instead of overflowing the card.
        min-width: 0;

        @include mixins.unsafe-html-content;
    }

    &__isi {
        display: block;
        margin-top: 8px;
        font-size: mixins.get-font-size(text-xs);
        font-weight: 700;
        line-height: mixins.get-line-height(text-xs);
        color: mixins.get-color(text, text-primary);
        --vm-clamped-text-bg: #{mixins.get-color(background, bg-white)};

        p {
            margin: 0 0 8px;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            color: mixins.get-color(text, text-primary);
            font-weight: 700;
            margin: 8px 0 4px;
        }

        @include mixins.unsafe-html-links;
    }

    &__learn-more {
        width: 100%;
        background: mixins.get-color(bg, solid, primary);
        border-radius: 100px;
    }
}
